import script from "./AmountSet.vue?vue&type=script&lang=ts&setup=true"
export * from "./AmountSet.vue?vue&type=script&lang=ts&setup=true"

import "./AmountSet.vue?vue&type=style&index=0&id=8128b7ba&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8128b7ba"]])

export default __exports__